// extracted by mini-css-extract-plugin
export var banner = "_gq-0";
export var closeButton = "_gq-2";
export var greenCheckmark = "_gq-3";
export var hereLink = "_gq-4";
export var titleIcon = "_gq-1";